import { globalRef, isBrowser } from './slim/config';
// Default event collectors
import { errors } from './metrics/errors';
import { navigationTiming } from './metrics/navigation';
// IIFE to avoid tree-shaking of default event collectors
export var SplitRumAgent = (function (SplitRumAgent) {
    if (isBrowser) {
        SplitRumAgent.register(errors());
        SplitRumAgent.register(navigationTiming());
    }
    return SplitRumAgent;
})(globalRef.SplitRumAgent);
